<template>
  <div class="card">
    <input ref="fileInput" type="file" v-show="false" :accept="acceptTypes" @change="fileChange($event)" />
    <div class="card-header">
      <div class="row">
        <h3 class="col mb-0">{{ $t('importtask.settings_title') }} <span v-if="advancedMode" style="color: red"> ({{ $t('importtask.advancedMode') }})</span></h3>
      </div>
    </div>
    <div class="card-body">
      <form-container
      v-if="formControl"
      ref="formContainer"
      v-bind:model-state="modelState"
      v-bind:error-message="formError"
      :orientation="'horizontal'"
    >
    <div class="row">
      <div class="col">
        <form-wrapper v-if="formItems && formItems.Destination" :formConfig="formItems.Destination" @change="destinationChange" class="mb-1"></form-wrapper>
        <div class="text-right form-group">
          <a @click="generateTemplate(null)" href="javascript:void(0)" class="p-0 border-0">{{ $t('importtask.generate_template') }}</a>
        </div>
        <div class="row">
          <div class="col-md-4">
            <label class="col-form-label form-group">{{ $t('importtask.labels.filename') }} </label>
          </div>
          <div class="col">
            <text-input :overrideInputCss="'col-md-12'" v-if="formItems && formItems.FileName" v-bind="formItems.FileName" v-model="formItems.FileName.value"></text-input>
          </div>
          <div class="col-auto pl-0">
            <loading-button :btn-class="'btn-primary'" :title="$t('importtask.select_file')" @click="openFileInput" />
          </div>
        </div>
        <form-wrapper :formConfig="formItems.Overwrite"></form-wrapper>
      </div>
      <div class="col">
        <select-input v-bind="formItems.DecimalNotation" v-model="formItems.DecimalNotation.value" />
        <select-input v-bind="formItems.BooleanNotation" v-model="formItems.BooleanNotation.value" />
        <select-input v-bind="formItems.DateTimeNotation" v-model="formItems.DateTimeNotation.value" />
      </div>
    </div>
    </form-container>
      
      <div class="row">
        <div class="col">
          <hr />
          <div class="row">
            <div class="col d-flex align-items-center">
              <a v-if="!advancedMode" href="javascript:void(0)" class="btn-link p-0 border-0" style="line-height: 1.4;" @click="modalOpen = true">{{ $t('importtask.open_advanced_mode') }}</a>
            </div>
            <div class="col-auto">
              <loading-button :enabled="fileUploaded" :btn-class="'btn-primary'" :title="$t('importtask.start_import')" @click="startImport" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <verification v-if="modalOpen" @close="modalOpen = false" @setAdvancedMode="advancedMode = true" />
    <specify-template-type v-if="openTypeModal && formItems" @close="openTypeModal = false" @generate="generateTemplate" :destination="formItems.Destination.value"/>
  </div>
</template>
<script>
import formmixin from '@/forms/components.js';
import { i18n } from '@/localize';
import { BooleanNotation, DateTimeNotation, DecimalNotation, ExportLayout } from 'libs/enums.js';

import { FormBooleanConfig, FormConfig, FormControl, FormSelectConfig, FormTextAreaConfig, FormTextConfig, ListFormConfig } from 'libs/classes/form.js';
import { decimalNotation, booleanNotation, dateTimeNotation } from '@/components/Export/notations';
import VerificationCode from './components/VerificationCode.vue';
import SpecifyTemplateType from './components/SpecifyTemplateType.vue';

import ImportController from '@/controller/importcontroller.js';
import fetchHelper from '@/libs/fetchcontroller';
import { geturi } from '@/libs/utils';
import ApiController from 'controller/apicontroller';
import ListConfig from '@/libs/classes/listconfig';


const controller = new ImportController();
export default {
  mixins: [formmixin],
  name: 'start-import',
  components: {
    'verification': VerificationCode,
    'specify-template-type': SpecifyTemplateType
  },
  props: {
    fetchDestination: {
      default: ''
    }
  },
  data() {
    return {
      modelState: null,
      formError: null,
      formControl: null,
      formItems: null,
      modalOpen: false,
      advancedMode: false,
      fileUploaded: false,
      file: null,
      fileName: null,
      destination: null,
      openTypeModal: false,
      zipFileImportDestinations: [18,30,31,32,33],  // 18 is objectmiimport different filetype (zip) / 30 (Productimage) / 31 (ProductCategoryImage) / 32 (LocationImage) / 33 (ObjectImage)
    };
  },
  async mounted(){
    this.advancedMode = await controller.GetAdvancedMode();
    await this.FetchDestinations();
  },
  methods: {
    destinationChange(){
     
      let destinationValue = this.formItems.Destination.value;
      
      if(this.destination == null && this.zipFileImportDestinations.includes(destinationValue)){
        this.resetFile();
      }

      if(this.destination){
        if(!this.zipFileImportDestinations.includes(this.destination) && this.zipFileImportDestinations.includes(destinationValue)){
          this.resetFile();
        }
        if(this.zipFileImportDestinations.includes(this.destination) && !this.zipFileImportDestinations.includes(destinationValue)){
          this.resetFile();
        }
      }
      this.destination = destinationValue;
    },
    resetFile(){
      this.file = null;
      this.fileName = null;
      this.formItems.FileName.value = null;
      this.fileUploaded = false;
    },
    async FetchDestinations(){
      let filter = this.fetchDestination;

      let destinations = await controller.GetDestinations(filter);

      let formControl = this.loadForm();
        let defaultDestination = 0;

      if(this.fetchDestination !== ''){
        defaultDestination = destinations[0].value;
      }
      formControl.add(new FormSelectConfig('Destination', i18n.t('importtask.choice'), defaultDestination , destinations, true));
      this.formControl = formControl;
      this.formItems = this.formControl.config;
    },
    loadForm(){
      const form = new FormControl();
      const fileName = new FormTextConfig('FileName', '', null);
      fileName.enabled = false;
      form.add(fileName);
      form.add(new FormBooleanConfig('Overwrite', i18n.t('importtask.labels.overwrite'), null));
      form.add(new FormSelectConfig('DecimalNotation', i18n.t('exportdialog.decimalnotation.title'), DecimalNotation.Comma, decimalNotation, true));
      form.add(new FormSelectConfig('BooleanNotation', i18n.t('exportdialog.booleannotation.title'), BooleanNotation.TrueFalse, booleanNotation, true));
      form.add(new FormSelectConfig('DateTimeNotation', i18n.t('exportdialog.datetimenotation.title'), DateTimeNotation.DMYYYY, dateTimeNotation, true));

      return form;
    },
    openFileInput(){
      this.$refs.fileInput.click();
    },
    async fileChange(event) {
      this.file = event.target.files[0];
      
      this.fileUploaded = true;

      let fileName = this.file.name;
      this.formItems.FileName.value = fileName;
    },
    async startImport(){
      const self = this;
      let formdata = new FormData();
      formdata.append('Destination', this.formItems.Destination.value);
      
      formdata.append('File', this.file);

      formdata.append('Overwrite', this.formItems.Overwrite.value);
      formdata.append('BooleanFormat', this.formItems.BooleanNotation.value);
      formdata.append('DecimalFormat', this.formItems.DecimalNotation.value);
      formdata.append('DateFormat', this.formItems.DateTimeNotation.value);

      const loader = this.$dialogs.loader('');
      try {
        this.formError = null;
        let result = await fetchHelper.postFile(geturi('mvc/import/StartImport'), formdata);
        this.$emit('importCreated', result);
      }
      catch(error){
        error.then(result => {
          if(result.Error){
            self.formError = result.Error;
          }
        });
      }
      finally {
        loader();
      }
    },
    async generateTemplate(chosenTypeId = null){
      let destination = this.formItems.Destination.value;
      let data = {
          Destination: destination,
          ObjectTypeID: null, 
          LocationTypeID: null
      };


      if([10,13].includes(destination)){

        if(chosenTypeId == null && !this.openTypeModal){
          this.openTypeModal = true;
          return;
        }
        else {
          if(destination === 13){
            data.ObjectTypeID = chosenTypeId;
          }
          if(destination === 10){
            data.LocationTypeID = chosenTypeId;
          }
        }
      }

      this.openTypeModal = false;
      const loader = this.$dialogs.loader();

      try {
        let response = await this.downloadTemplate(data);
        const contentDisposition = response.headers.get('content-disposition');
        // Can only be resolved in production
        let filename = contentDisposition ? contentDisposition.split('filename=')[1] : 'import_template.xlsx'; 

        filename = filename.replace(/['"]+/g, '');

        const url = window.URL.createObjectURL(await response.blob());
        const link = document.createElement('a');

        link.href = url;
        link.download = filename.trim();
        document.body.appendChild(link);
        link.click();

        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      } 
      catch(error){
        if(error.Error){
          this.$toaster.showError(error.Error);
        }
      }
      finally {
        loader();
      }
    },
    async downloadTemplate(data){
      let uri = `${ApiController.BaseURI}mvc/import/GenerateTemplate`;

      const response = await fetch(uri, {
        method: 'post',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json; charset=utf-8'
        },
        body: JSON.stringify(data)
      });

      if (response.ok) return response;
      else {
        const error = await response.json();
        return Promise.reject(error);
      }
    }
  },
  computed: {
    acceptTypes(){
      if(this.formItems && this.formItems.Destination && this.zipFileImportDestinations.includes(this.formItems.Destination.value)){
        return '.zip, application/zip';
      }
      return '.xls, .xlsx';
    }
  }
};
</script>
